/* eslint-disable no-template-curly-in-string */
import { component } from "picoapp";
import { currencySymbol, formatMoney } from "../../../scripts/lib/currency";
import { TablescapeState } from "../../state";

export const productIntro = component((node: HTMLElement, context) => {
  const priceElement = node.querySelector("[data-price]");
  const compareAtPriceElement = node.querySelector("[data-compare-at-price]");

  const updateVariantPrices = (variant) => {
    const currency = currencySymbol();
    if (priceElement) {
      const priceTextNode = priceElement.querySelector(
        "[data-tbsp-component='text']"
      );

      priceTextNode.textContent = variant.price
        ? `${currency}${formatMoney(
            variant.price,
            "{{ amount_no_trailing_zeroes }}",
            false
          )}`
        : "";

      if (variant.compare_at_price) {
        priceTextNode.classList.add("text-interactive-brick");
      } else {
        priceTextNode.classList.remove("text-interactive-brick");
      }
    }

    if (compareAtPriceElement) {
      const compareAtPriceTextNode = compareAtPriceElement.querySelector(
        "[data-tbsp-component='text']"
      );
      compareAtPriceTextNode.textContent = variant.compare_at_price
        ? `${currency}${formatMoney(
            variant.compare_at_price,
            "{{ amount_no_trailing_zeroes }}",
            false
          )}`
        : "";
    }
  };

  const updateVariantSalesBadge = (variant) => {
    const { variantMetafields }: TablescapeState = context.getState();
    const salesBadge = node.querySelector("#sales-badge");
    if (!salesBadge) return;
    const badgeNode = salesBadge.querySelector(
      "[data-tbsp-component='badge']"
    ) as HTMLElement;
    if (!badgeNode) return;

    const salesBadgeText = variantMetafields[`${variant.id}`]?.badge.sale;
    if (salesBadgeText) {
      badgeNode.innerHTML = salesBadgeText;
      badgeNode.style.display = "block";
    } else {
      badgeNode.style.display = "none";
      badgeNode.innerHTML = "";
    }
  };

  context.on("tbsp:variant-selected", (variant) => {
    updateVariantPrices(variant);
    updateVariantSalesBadge(variant);
  });
});
